
<div class="um-wrap">

  <ul class="nav nav-tabs um-tabs" role="tablist">

    <li *ngFor="let dashboard of loginService.user.dashboards" class="nav-item" role="presentation">
      <button type="button"
              class="nav-link"
              role="tab"
              [class.active]="dashboard.dashboardId === selectedDashboard.dashboardId"
              [attr.aria-selected]="dashboard.dashboardId === selectedDashboard.dashboardId ? 'true' : 'false'"
              (click)="setSelectedDashboard(dashboard)"
              [attr.id]="'tab-' + dashboard.dashboardId">
        {{ dashboard.name }}
      </button>
    </li>

  </ul>

  <div class="tab-content um-tab-content">

    <wc-grid [dashboardId]="selectedId" [contextMenuItems]="gridMenu"
             [showQuickSearch]="true" searchPlaceholder="Type to filter wells..."
             (contextMenuAction)="onGridMenu($event)"/>
  </div>

</div>
